import React from "react";
import { PageHero, PageBody } from "./_shared";
import { usePoly } from "./PolyLayout";
import FacilitiesGrid from "@/components/FacilitiesGrid";

export default function Facilities() {
  const data = usePoly();
  const items = data?.facilities || [];
  return (
    <div data-testid="mitest-facilities">
      <PageHero eyebrow="Campus" title="World-class Facilities" accent="blue" />
      <PageBody>
        <FacilitiesGrid
          items={items}
          testidPrefix="mitest-facilities"
          accentChipClass="bg-blue-500/10 text-blue-700 ring-1 ring-blue-500/20"
        />
      </PageBody>
    </div>
  );
}
